module.exports = __webpack_public_path__ + "img/100banner-new.6971b7a9.jpg";